/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * HomeIcon
 */
export default class HomeIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M11.4 1.4c.3-.3.8-.3 1.2 0l10 8c.4.4.5 1 .2 1.4-.2.3-.5.4-.8.4-.2 0-.4-.1-.6-.2l-.4-.319V20c0 1.64-1.209 2.907-2.82 2.995L18 23H6c-1.7 0-3-1.3-3-3v-9.319L2.6 11c-.37.277-.994.213-1.324-.113L1.2 10.8c-.3-.4-.2-1 .2-1.4zm.6 2.1L5 9.085V20c0 .557.345.942.875.994L6 21h2v-7a2 2 0 011.85-1.995L10 12h4a2 2 0 011.995 1.85L16 14v7h2c.6 0 1-.4 1-1V9.085L12 3.5zM14 14h-4v7h4v-7z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

